import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import EncuestaPublica from './features/encuestas/EncuestaPublica';
import RegistroAsistencia from './features/registro/RegistroAsistencia';
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

function PaginaRegistro() {
  const { servicioId, codigo } = useParams();
  return <RegistroAsistencia servicioId={servicioId} codigo={codigo} />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/encuesta/:id" element={<EncuestaPublica />} />
        <Route path="/registro/:servicioId/:codigo" element={<PaginaRegistro />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
